import { render, staticRenderFns } from "./CustomBusinessSection.vue?vue&type=template&id=073d7620&scoped=true&"
import script from "./CustomBusinessSection.vue?vue&type=script&lang=ts&"
export * from "./CustomBusinessSection.vue?vue&type=script&lang=ts&"
import style0 from "./CustomBusinessSection.vue?vue&type=style&index=0&id=073d7620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d7620",
  null
  
)

export default component.exports